export default __webpack_public_path__ + "media/images/dashboard_icons/document-0908d06f6c030b7522c9c18d827b8312.svg";